import { render, staticRenderFns } from "./LogoMain.vue?vue&type=template&id=797ce68d&scoped=true&"
import script from "./LogoMain.vue?vue&type=script&lang=js&"
export * from "./LogoMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ce68d",
  null
  
)

export default component.exports